import internalApi from './internalApi'

/* Référentiel produits (F3) — servi par admin-service.
   Source unique : aucune liste recopiée dans le React, même principe que
   /admin/references/type-lieu pour F1. */

export interface ProduitCategorie {
  id: number
  libelle: string
  ordre: number
}

export interface Produit {
  id: number
  libelle: string
  actif: boolean
  categorie: ProduitCategorie
}

export async function getCategories(): Promise<ProduitCategorie[]> {
  const res = await internalApi.get('/produit/categories')
  return Array.isArray(res.data) ? res.data : []
}

export async function getProduits(actif?: boolean): Promise<Produit[]> {
  const res = await internalApi.get('/produits', {
    params: actif === undefined ? {} : { actif },
  })
  return Array.isArray(res.data) ? res.data : []
}

export const creerCategorie   = (libelle: string) =>
  internalApi.post('/produit/categories', { libelle })

export const modifierCategorie = (id: number, corps: { libelle?: string; ordre?: number }) =>
  internalApi.put(`/produit/categories/${id}`, corps)

/* Échange avec la voisine et renumérote côté serveur, en une transaction (Z2-39). */
export const deplacerCategorie = (id: number, sens: 'haut' | 'bas') =>
  internalApi.post(`/produit/categories/${id}/deplacer`, { sens })

export const supprimerCategorie = (id: number) =>
  internalApi.delete(`/produit/categories/${id}`)

export const creerProduit = (libelle: string, categorieId: number) =>
  internalApi.post('/produits', { libelle, categorieId })

export const modifierProduit = (id: number, corps: { libelle?: string; categorieId?: number }) =>
  internalApi.put(`/produits/${id}`, corps)

/* Un produit ne se supprime pas : il se désactive. Il reste ainsi lisible sur
   les quêtes qui le référencent, tout en sortant des sélecteurs. */
export const basculerActif = (id: number, actif: boolean) =>
  internalApi.patch(`/produits/${id}/actif`, { actif })

/** Message d'erreur du serveur, à afficher tel quel. */
export function messageErreur(err: any, defaut: string): string {
  const d = err?.response?.data
  if (typeof d === 'string' && d.trim()) return d.trim()
  if (d && typeof d.message === 'string' && d.message.trim()) return d.message.trim()
  return defaut
}
